module.exports = __webpack_public_path__ + "img/maxicash-logo.07224287.png";